import {FunctionComponent, MouseEventHandler} from 'react';

export type TabOptionType = {
    label: string,
    value: any
};

export type TabsItemProps = {
    idPrefix: string,
    item: TabOptionType,
    isSelected?: boolean,
    onClick: (value: any) => void
}

const TabsItem: FunctionComponent<TabsItemProps> = (props) => {

    const handleClick: MouseEventHandler<HTMLAnchorElement> = (event) => {
        event.preventDefault();
        props.onClick(props.item.value);
    };

    return (
        <li className="dfb-Tabs-item" id={`${props.idPrefix}-${props.item.value}`}>
            <a className="dfb-Tabs-tab" href="#tab" onClick={handleClick} aria-selected={!!props.isSelected} tabIndex={-1} role="tab">
                <div className="dfb-Tabs-labelContainer">
                    <span className="dfb-Tabs-tabLabel">{props.item.label}</span>
                </div>
            </a>
        </li>
    );
};

export default TabsItem;
